var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageNo"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('../assets/images/pageNone.png'),"description":"抱歉，页面不见了~"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }